/**
 * Bandeau de consentement natif Shopify — correction de la hiérarchie des titres.
 *
 * Shopify injecte les titres de son UI de consentement dans des <h2> :
 *   - « #shopify-pc__banner__body-title »   -> titre du bandeau
 *   - « #shopify-pc__prefs__header-title »  -> titre de la fenêtre de préférences
 * Cette UI étant ajoutée très tôt dans le DOM, ces <h2> apparaissent AVANT le <h1> de la page et
 * cassent la hiérarchie des titres (mauvais pour le SEO / l'outline du document).
 *
 * Le markup n'étant pas modifiable depuis le thème, on remplace ces <h2> par des <div>
 * après injection :
 *   - l'id est conservé (styles CSS + `aria-labelledby` des dialogues restent valides) ;
 *   - les marges calculées du <h2> sont recopiées pour ne rien changer visuellement.
 */
(function () {
  'use strict';

  var TITLE_IDS = ['shopify-pc__banner__body-title', 'shopify-pc__prefs__header-title'];
  var MARGINS = ['marginTop', 'marginRight', 'marginBottom', 'marginLeft'];

  function downgradeTitle(id) {
    var title = document.getElementById(id);

    if (!title || !/^H[1-6]$/.test(title.tagName)) {
      return;
    }

    var replacement = document.createElement('div');
    var computed = window.getComputedStyle(title);

    Array.prototype.forEach.call(title.attributes, function (attribute) {
      replacement.setAttribute(attribute.name, attribute.value);
    });

    MARGINS.forEach(function (property) {
      replacement.style[property] = computed[property];
    });

    replacement.innerHTML = title.innerHTML;
    title.replaceWith(replacement);
  }

  function downgradeTitles() {
    TITLE_IDS.forEach(downgradeTitle);
  }

  downgradeTitles();

  // L'UI de consentement est injectée de façon asynchrone par Shopify (et la fenêtre de préférences
  // seulement à l'ouverture) : on surveille le DOM en continu. Opération négligeable, la fonction
  // sort immédiatement si un titre est absent ou déjà converti.
  new MutationObserver(downgradeTitles).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
